import { z } from "zod";
import { faceMaskMode } from "../face-swap-video/constant";

export const frameCostPerFaceSwapImage = 5;

export const tool = "face-swap-photo";

export const schema = z
  .object({
    sourceImage: z.instanceof(File).optional(),
    sourceImagePath: z.string().optional(),
    targetImage: z.instanceof(File).optional(),
    targetImagePath: z.string().optional(),
    faceMaskMode: z.enum(faceMaskMode).default("smart"),
  })
  .superRefine((data, ctx) => {
    if (!data.sourceImage && !data.sourceImagePath) {
      ctx.addIssue({
        path: ["sourceImage"],
        message: "Please upload the face you want to use or use a preset",
        code: z.ZodIssueCode.custom,
      });
    }
    if (!data.targetImage && !data.targetImagePath) {
      ctx.addIssue({
        path: ["targetImage"],
        message: "Please upload a image to swap faces into or use a preset",
        code: z.ZodIssueCode.custom,
      });
    }
  });
